var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#D5F7DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9V11.5L16.6295 10.1295L15.5 9H18Z",
    fill: "#07AF25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15L10.0667 10.3846L12.4 13.6154L16.6295 10.1295M16.6295 10.1295L18 9M16.6295 10.1295L18 11.5V9M16.6295 10.1295L15.5 9H18",
    stroke: "#07AF25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsUp);
export default __webpack_public_path__ + "static/media/stats-up.92da7fb88009d2294d27defca4b0bfaf.svg";
export { ForwardRef as ReactComponent };